var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-72 rounded-lg bg-white shadow",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"p-6 pb-0 text-center"},[_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"p-6 text-center"},[_vm._t("content")],2),_vm._v(" "),_c('div',{staticClass:"p-6 pt-0"},[_vm._t("action")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }